import styled from 'styled-components';

export const MainStyled = styled.div`
  background: var(--dblue);
  position: relative;
  margin-bottom: 150px;
  //   height: 728px;
  > .container {
    display: flex;
    flex-direction: column;
    padding: 0 20px;
    padding-bottom: 145px;
  }
  @media (min-width: 992px) {
    background: linear-gradient(
      180deg,
      rgba(136, 151, 165, 0) 0%,
      rgba(136, 151, 165, 0.2) 100%
    );
    height: 360px;
    margin-bottom: 0;
  }
`;

export const Title = styled.h1`
  color: var(--black);
  font-family: Rubik;
  font-size: 32px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 40px;
  text-align: center;
  margin-bottom: 180px;
  margin-top: -230px;
  @media (min-width: 992px) {
    margin-bottom: 60px;
    margin-top: 0;
    br {
      display: none;
    }
  }
`;

export const Card = styled.div`
  box-sizing: border-box;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 184px;
  width: 100%;
  border-radius: 20px;
  background-color: var(--white);
  box-shadow: 0 5px 50px 0 rgba(4, 30, 66, 0.1);
  position: relative;
  z-index: 1;
  visibility: visible;
  .social {
    a {
      img {
        height: 40px;
        width: 40px;
        &:nth-of-type(2) {
          display: none;
        }
        @media (min-width: 992px) {
          height: 32px;
          width: 32px;
        }
      }
      &:hover {
        img {
          &:nth-of-type(1) {
            display: none;
          }
          &:nth-of-type(2) {
            display: inline;
          }
        }
      }
      &:not(:last-of-type) {
        margin-right: 16px;
        @media (min-width: 992px) {
          margin-right: 8px;
        }
      }
    }
  }
  .heading {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .social {
      @media (min-width: 992px) {
        display: none;
      }
    }
    @media (min-width: 992px) {
      justify-content: center;
    }
  }
  .name {
    color: var(--black);
    font-family: Rubik;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 24px;
    text-align: center;
    margin-top: 15px;
    @media (min-width: 992px) {
      margin-top: 23px;
    }
  }
  .role {
    color: var(--gray);
    font-family: Rubik;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
    text-align: center;
  }
  > .social {
    display: none;
    @media (min-width: 992px) {
      display: block;
      margin-top: auto;
    }
  }
  &:not(:last-of-type) {
    margin-bottom: 24px;
    @media (min-width: 992px) {
      margin-bottom: unset;
      margin-right: 24px;
    }
  }
  &.hide {
    visibility: hidden;
  }
  @media (min-width: 992px) {
    height: 290px;
    width: 264px;
    padding: 32px;
    align-items: center;
  }
`;

export const AvatarContainer = styled.div`
  height: 80px;
  width: 80px;
  > img {
    border-radius: 50%;
    width: 100%;
    object-fit: cover;
  }
  @media (min-width: 992px) {
    height: 104px;
    width: 104px;
  }
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: -105px;
  margin-bottom: -185px;
  @media (min-width: 992px) {
    flex-direction: row;
    justify-content: space-between;
    margin: 0;
  }
`;

export const DiagonalBlueData = styled.div`
  width: 100%;
  height: 100px;
  clip-path: polygon(300% 0%, 100% 0%, 100% 100%, 0% 100%);
  position: absolute;
  z-index: 0;
  left: 0;
  right: 0;
  &:first-of-type {
    top: -100px;
    background-color: var(--dblue);
  }
  &:last-of-type {
    bottom: 0;
    background-color: var(--white);
  }
  @media (min-width: 992px) {
    clip-path: polygon(100% 0%, 100% 0%, 100% 100%, 0% 100%);
    display: none;
  }
`;
